module.exports = __webpack_public_path__ + "static/media/animation-header.ea563316.gif";